import { Drawer } from 'antd';
import { useUnit } from 'effector-react';
import {
  $mobilePopup,
  resetMobilePopupEv,
} from '../../models/centerHomeModel/index.js';
import CenterHomeListPopup from './CenterHomeListPopup.jsx';
import CenterHomePopup from './CenterHomePopup.jsx';

function CenterHomeMobilePopup() {
  const mobilePopup = useUnit($mobilePopup);
  const resetMobilePopup = useUnit(resetMobilePopupEv);

  if (!mobilePopup) return;

  return (
    <Drawer
      placement="bottom"
      open={!!mobilePopup}
      closable={false}
      maskClosable
      onClose={resetMobilePopup}
    >
      {mobilePopup.length > 1 ? (
        <CenterHomeListPopup features={mobilePopup} closeable={false} />
      ) : (
        <CenterHomePopup feature={mobilePopup[0]} popup={false} />
      )}
    </Drawer>
  );
}

export default CenterHomeMobilePopup;
